import script from "./MfaLoginModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MfaLoginModal.vue?vue&type=script&setup=true&lang=js"

import "./MfaLoginModal.vue?vue&type=style&index=0&id=93f64970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93f64970"]])

export default __exports__